import Helpers from '@assets/scripts/helpers';

const state = {
	showCreateNew: false,
};

export default () => Helpers.cloneObject(state);
